
export enum DependencyType {
    Child,
    PrincipalAlwaysLast
}
